import { render, staticRenderFns } from "./SliderV1.vue?vue&type=template&id=12368d7b&"
import script from "./SliderV1.vue?vue&type=script&lang=js&"
export * from "./SliderV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports